import styles from './ListViewColumn.module.scss'
import React from 'react'
import { ListViewColumn } from '../ListView/ListView'
import classNames from 'classnames'

type Props = {
  column: ListViewColumn,
  children: React.ReactNode,
}

const ListViewColumn = (props: Props) => {
  if(props.column?.hidden) return null

  return (
    <div className={classNames(styles.component, props.column?.className)}>
      <div className={styles.label}>
        {props.column?.label}
      </div>
      <div>
        {props.children}
      </div>
    </div>
  )
}

export default ListViewColumn